import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviationTier } from '@wix/da-papi-types';
import TierIcon from '@wix/da-ds/pkg/Icons/16x16/Tier';
import BoostIcon from '@wix/da-ds/pkg/Icons/16x16/BoostFilled';
import StatisticsBar, { Props as StatisticsBarProps } from './StatisticsBar';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import s from './TierStatisticsBar.scss';

interface Props extends Omit<StatisticsBarProps, 'stats'> {
  stats: PapiDeviationTier['stats'];
  isBoosted?: boolean;
}

/** Statistics bar specifically for Tiers to consolidate some code.
 *  Currently only shows subscriber counts (if any) */
const TierStatisticsBar: React.FC<Props> = ({ stats, isBoosted, className }) => {
  const { t } = useTranslation();
  const numSubscribers = stats?.subscribers;
  if (!numSubscribers && !isBoosted) {
    return null;
  }

  return (
    <div className={c(s['root'], className)}>
      {!!numSubscribers && (
        <StatisticsBar
          className={s['stats']}
          stats={[
            {
              icon: TierIcon,
              label: t('deviationview.tierCard.subscribers', {
                count: numSubscribers,
              }),
            },
          ]}
        />
      )}
      {isBoosted && (
        <div className={s['boosted']}>
          <BoostIcon size={IconSize.SMALLER} disableDefaultColors />
          <span className={s['boosted-text']}>{t('common.boosted')}</span>
        </div>
      )}
    </div>
  );
};

TierStatisticsBar.displayName = 'TierStatisticsBar';
export default TierStatisticsBar;
